module.exports = {
  label: {
    name: 'Name',
    phoneNumber: 'Phone Number',
    emailId: 'Email ID',
    dob: 'Date of Birth',
    date: 'Date',
    gender: 'Gender',
    bloodGroup: 'Blood Group',
    address: 'Address',
    receivedDate: 'Received date',
    sentDate: 'Sent date',
    glp: 'GLP',
    successfullyAssigned: 'Request assigned successfully',
    nodata:'----',
    male:'Male',
    female:'Female',
    other:'Other',
    noDataFound:'No Data Found',
    error:'Something Went Wrong',
    rejected:'REJECTED'
  }
}
